var _regeneratorRuntime = require("/vercel/workpath0/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/asyncToGenerator");

function getChainId(_x) {
  return _getChainId.apply(this, arguments);
}

function _getChainId() {
  _getChainId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(web3) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              web3.currentProvider.send({
                method: "eth_chainId",
                params: [],
                jsonrpc: "2.0",
                id: 1
              }, function (err, response) {
                if (err) {
                  reject();
                } else {
                  resolve(response.result);
                }
              });
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getChainId.apply(this, arguments);
}

module.exports = getChainId;